"use strict";

require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSessions = exports.getSessions = exports.clearSessions = void 0;
require("core-js/modules/es.promise.js");
var _react = _interopRequireWildcard(require("react"));
var _GetData = _interopRequireDefault(require("./GetData"));
var _StoreData = _interopRequireDefault(require("./StoreData"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * API Core Session Component Holder
 * Sam Ayoub <melayyoub@svb.com> (svb.com)
 * Decsriptio: Here where we convert and check access of values from the Session component
 * To use this component it's a simple request with your component
 * as for testing we request there's only 3 options to use exported from this component ClearSessions, SetSessions, GetSessions
 * get the value of the field by request
 * Store Options : Local, Cookie, Session, 
 * Data is always an array of objects with Key and Value in each object
 * How to use? Readme.md
 */

/**
  * Set Sessions value(s) to user sessions
  * @param {String} store 
 * ex. session, local, cookies
 * @param {Array} data 
 * ex. [{key: "test", value:"email@test.com"}, ..]
  */
const setSessions = async (store, data) => {
  // Validation of input
  if (store !== 'local' && store !== 'session' && store !== 'cookies') {
    return false;
  }
  if (data.length <= 0) {
    return false;
  }
  return await (0, _StoreData.default)(store, data);
};

/**
 * Get value from this user Session
 * @param {String} store 
 * ex. session, local, cookies
 * @param {Array} data 
 * ex. get([{key: 'username'}])
 */
exports.setSessions = setSessions;
const getSessions = async (store, data) => {
  // Validation of input
  if (store !== 'local' && store !== 'session' && store !== 'cookies') {
    return false;
  }
  if (data.length <= 0) {
    return false;
  }
  return await (0, _GetData.default)(store, data);
};

/**
 * Clear all Sessions this function preferred to be used only in logout process
 * @returns true
 */
exports.getSessions = getSessions;
const clearSessions = async () => {
  sessionStorage.clear();
  localStorage.clear();
  _jsCookie.default.remove('data');
  console.clear();
  return;
};
exports.clearSessions = clearSessions;